<template>
  <div class="page-wrap student-manage">
    <page-header :title="$route.meta.title">
      <template>
        <div
          class="page-header-handle-wrap"
          v-if="handleRightsList.includes('新增')"
        >
          <a-dropdown class="handle-title">
            <div class="page-header-handle-item">
              <!-- <img
                class="handle-icon"
                src="../../assets/img/icon/新增账户.png"
              /> -->
              <span>
                {{ $t('student.newStudent') }} <a-icon type="down" />
              </span>
            </div>
            <a-menu slot="overlay">
              <a-menu-item @click="handleAdd">
                {{ $t('student.addStudent') }}
              </a-menu-item>
              <!-- <a-menu-item>批量导入</a-menu-item> -->
            </a-menu>
          </a-dropdown>
        </div>

        <div class="page-header-handle-wrap">
          <div
            v-for="(item, index) in categoryRouterList"
            :key="index"
            class="page-header-handle-item"
            :class="{
              'active-handle': $route.name === item.name
            }"
            @click="handleTap(item)"
          >
            <img
              class="handle-icon"
              :src="item.meta.icon"
              :alt="item.meta.title"
            />
            <div class="handle-title">{{ $t(item.meta.title) }}</div>
          </div>
        </div>
      </template>
    </page-header>

    <transition name="default" mode="out-in">
      <router-view
        :update-component="updateComponent"
        :key="$route.path"
      ></router-view>
    </transition>

    <a-drawer
      :title="$t('public.add', { content: $t('public.student_lower') })"
      :visible="drawerVisible"
      :width="500"
      wrapClassName="drawer-form-wrap"
      @close="handleClose"
    >
      <div class="form-wrap">
        <a-form :form="form">
          <a-form-item
            :labelCol="formItemLayout.labelCol"
            :wrapperCol="formItemLayout.wrapperCol"
            :label="$t('student.majorType')"
          >
            <a-select
              :placeholder="$t('student.majorType')"
              v-decorator="[
                'majorType',
                {
                  rules: [
                    {
                      required: true,
                      message: $t('public.pleaseFill', {
                        content: $t('student.majorType')
                      })
                    }
                  ]
                }
              ]"
            >
              <a-select-option
                v-for="item in studentMajorOption"
                :key="item.name"
                :value="item.name"
              >
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <!-- <a-form-item
            label="账号"
            :extra="
              `${
                form.getFieldValue('loginName')
                  ? form.getFieldValue('loginName').length
                  : '0'
              }/64`
            "
            :labelCol="formItemLayout.labelCol"
            :wrapperCol="formItemLayout.wrapperCol"
          >
            <a-input
              maxLength="64"
              type="number"
              placeholder="账号"
              v-decorator="[
                'loginName',
                {
                  rules: [{ required: true, message: '请填写账号！' }]
                }
              ]"
            >
            </a-input>
          </a-form-item> -->

          <a-form-item
            :label="$t('public.chineseName')"
            :extra="
              `${
                form.getFieldValue('name')
                  ? form.getFieldValue('name').length
                  : '0'
              }/64`
            "
            :labelCol="formItemLayout.labelCol"
            :wrapperCol="formItemLayout.wrapperCol"
          >
            <a-input
              maxLength="64"
              :placeholder="$t('public.chineseName')"
              v-decorator="[
                'name',
                {
                  rules: [
                    {
                      required: true,
                      message: $t('public.pleaseFill', {
                        content: $t('public.name')
                      })
                    }
                  ]
                }
              ]"
            >
            </a-input>
          </a-form-item>

          <a-form-item
            :label="$t('public.englishName')"
            :extra="
              `${
                form.getFieldValue('englishName')
                  ? form.getFieldValue('englishName').length
                  : '0'
              }/64`
            "
            :labelCol="formItemLayout.labelCol"
            :wrapperCol="formItemLayout.wrapperCol"
          >
            <a-input
              maxLength="64"
              :placeholder="$t('public.englishName')"
              v-decorator="[
                'englishName',
                {
                  rules: [
                    {
                      required: true,
                      message: $t('public.pleaseFill', {
                        content: $t('public.englishName')
                      })
                    }
                  ]
                }
              ]"
            >
            </a-input>
          </a-form-item>

          <a-form-item
            :label="$t('public.lastNameDetail')"
            :extra="
              `${
                form.getFieldValue('lastName')
                  ? form.getFieldValue('lastName').length
                  : '0'
              }/64`
            "
            :labelCol="formItemLayout.labelCol"
            :wrapperCol="formItemLayout.wrapperCol"
          >
            <a-input
              maxLength="64"
              :placeholder="$t('public.lastNameDetail')"
              v-decorator="[
                'lastName',
                {
                  rules: [
                    {
                      required: true,
                      message: $t('public.pleaseFill', {
                        content: $t('public.lastName_lower')
                      })
                    }
                  ]
                }
              ]"
            >
            </a-input>
          </a-form-item>

          <a-form-item
            :label="$t('public.fristName')"
            :extra="
              `${
                form.getFieldValue('firstName')
                  ? form.getFieldValue('firstName').length
                  : '0'
              }/64`
            "
            :labelCol="formItemLayout.labelCol"
            :wrapperCol="formItemLayout.wrapperCol"
          >
            <a-input
              maxLength="64"
              :placeholder="$t('public.fristName')"
              v-decorator="[
                'firstName',
                {
                  rules: [
                    {
                      required: true,
                      message: $t('public.pleaseFill', {
                        content: $t('public.firstName_lower')
                      })
                    }
                  ]
                }
              ]"
            >
            </a-input>
          </a-form-item>

          <a-form-item
            :label="$t('public.gender')"
            :labelCol="formItemLayout.labelCol"
            :wrapperCol="formItemLayout.wrapperCol"
          >
            <a-select
              :placeholder="$t('public.gender')"
              v-decorator="[
                'gender',
                {
                  rules: [
                    {
                      required: true,
                      message: $t('public.pleaseFill', {
                        content: $t('public.gender')
                      })
                    }
                  ]
                }
              ]"
            >
              <a-select-option
                v-for="(item, index) in genderList"
                :key="index"
                :value="item"
              >
                {{ $t($utils.filteGender(item, 'translate')) }}
              </a-select-option>
            </a-select>
          </a-form-item>

          <!-- <a-form-item
            label="手机"
            :extra="
              `${
                form.getFieldValue('mobile')
                  ? form.getFieldValue('mobile').length
                  : '0'
              }/11`
            "
            :labelCol="formItemLayout.labelCol"
            :wrapperCol="formItemLayout.wrapperCol"
          >
            <a-input
              type="tel"
              maxLength="11"
              placeholder="手机"
              v-decorator="[
                'mobile',
                {
                  rules: [
                    { required: true, message: '请填写手机！' },
                    {
                      pattern: /^[1][3,4,5,6,7,8,9][0-9]{9}$/,
                      message: '请填写正确手机！'
                    }
                  ]
                }
              ]"
            >
            </a-input>
          </a-form-item> -->

          <!-- <a-form-item
            label="邮箱"
            :extra="
              `${
                form.getFieldValue('email')
                  ? form.getFieldValue('email').length
                  : '0'
              }/64`
            "
            :labelCol="formItemLayout.labelCol"
            :wrapperCol="formItemLayout.wrapperCol"
          >
            <a-input maxLength="64" placeholder="邮箱" v-decorator="['email']">
            </a-input>
          </a-form-item> -->

          <a-form-item
            :label="$t('public.dateOfBirth')"
            :labelCol="formItemLayout.labelCol"
            :wrapperCol="formItemLayout.wrapperCol"
          >
            <a-date-picker
              style="width:100%"
              :placeholder="$t('public.dateOfBirth')"
              v-decorator="[
                'birthday',
                {
                  rules: [
                    {
                      required: true,
                      message: $t('public.pleaseFill', {
                        content: $t('public.dateOfBirth')
                      })
                    }
                  ]
                }
              ]"
            />
          </a-form-item>

          <a-form-item
            :label="$t('public.enrollmentGrade')"
            :labelCol="formItemLayout.labelCol"
            :wrapperCol="formItemLayout.wrapperCol"
          >
            <a-select
              :placeholder="$t('public.enrollmentGradeTitle')"
              v-decorator="[
                'enrollmentGrade',
                {
                  rules: [
                    {
                      required: true,
                      message: $t('public.pleaseFill', {
                        content: $t('public.enrollmentGrade_lower')
                      })
                    }
                  ]
                }
              ]"
            >
              <a-select-option
                v-for="(item, index) in gradeList"
                :key="index"
                :value="item.value"
              >
                {{ item.label }}
              </a-select-option>
            </a-select>
          </a-form-item>

          <a-form-item
            :label="$t('public.enrollmentTime')"
            :labelCol="formItemLayout.labelCol"
            :wrapperCol="formItemLayout.wrapperCol"
          >
            <a-select
              :placeholder="$t('public.enrollmentTime')"
              v-decorator="[
                'enrollmentTime',
                {
                  rules: [
                    {
                      required: true,
                      message: $t('public.pleaseFill', {
                        content: $t('public.enrollmentTime_lower')
                      })
                    }
                  ]
                }
              ]"
            >
              <a-select-option
                v-for="(item, index) in enrollmentYearList"
                :key="index"
                :value="item"
              >
                {{ item }}
              </a-select-option>
            </a-select>
          </a-form-item>

          <!-- <a-form-item
            label="地址"
            :extra="
              `${
                form.getFieldValue('address')
                  ? form.getFieldValue('address').length
                  : '0'
              }/100`
            "
            :labelCol="formItemLayout.labelCol"
            :wrapperCol="formItemLayout.wrapperCol"
          >
            <a-textarea
              maxLength="100"
              placeholder="地址"
              v-decorator="['address']"
            >
            </a-textarea>
          </a-form-item> -->

          <!-- <a-form-item
            label="监护人1姓名"
            :extra="
              `${
                form.getFieldValue('firstGuardian')
                  ? form.getFieldValue('firstGuardian').length
                  : '0'
              }/64`
            "
            :labelCol="formItemLayout.labelCol"
            :wrapperCol="formItemLayout.wrapperCol"
          >
            <a-input
              maxLength="64"
              placeholder="监护人1姓名"
              v-decorator="['firstGuardian']"
            >
            </a-input>
          </a-form-item> -->

          <!-- <a-form-item
            label="监护人1手机"
            :extra="
              `${
                form.getFieldValue('firstGuardianMobile')
                  ? form.getFieldValue('firstGuardianMobile').length
                  : '0'
              }/11`
            "
            :labelCol="formItemLayout.labelCol"
            :wrapperCol="formItemLayout.wrapperCol"
          >
            <a-input
              type="tel"
              maxLength="11"
              placeholder="监护人1手机"
              v-decorator="[
                'firstGuardianMobile',
                {
                  rules: [
                    {
                      pattern: /^[1][3,4,5,6,7,8,9][0-9]{9}$/,
                      message: '请填写正确手机！'
                    }
                  ]
                }
              ]"
            >
            </a-input>
          </a-form-item> -->

          <!-- <a-form-item
            label="监护人2姓名"
            :extra="
              `${
                form.getFieldValue('secondGuardian')
                  ? form.getFieldValue('secondGuardian').length
                  : '0'
              }/64`
            "
            :labelCol="formItemLayout.labelCol"
            :wrapperCol="formItemLayout.wrapperCol"
          >
            <a-input
              maxLength="64"
              placeholder="监护人2姓名"
              v-decorator="['secondGuardian']"
            >
            </a-input>
          </a-form-item> -->

          <!-- <a-form-item
            label="监护人2手机"
            :extra="
              `${
                form.getFieldValue('secondGuardianMobile')
                  ? form.getFieldValue('secondGuardianMobile').length
                  : '0'
              }/11`
            "
            :labelCol="formItemLayout.labelCol"
            :wrapperCol="formItemLayout.wrapperCol"
          >
            <a-input
              type="tel"
              maxLength="11"
              placeholder="监护人2手机"
              v-decorator="[
                'secondGuardianMobile',
                {
                  rules: [
                    {
                      pattern: /^[1][3,4,5,6,7,8,9][0-9]{9}$/,
                      message: '请填写正确手机！'
                    }
                  ]
                }
              ]"
            >
            </a-input>
          </a-form-item> -->

          <a-form-item
            :label="$t('public.remark')"
            :extra="
              `${
                form.getFieldValue('remark')
                  ? form.getFieldValue('remark').length
                  : '0'
              }/64`
            "
            :labelCol="formItemLayout.labelCol"
            :wrapperCol="formItemLayout.wrapperCol"
          >
            <a-textarea
              maxLength="64"
              :autosize="{ minRows: 3, maxRows: 6 }"
              :placeholder="$t('public.remark')"
              v-decorator="['remark']"
            >
            </a-textarea>
          </a-form-item>
        </a-form>
      </div>
      <div class="drawer-bottom-wrap">
        <a-button class="margin--right" @click="handleClose">
          {{ $t('handle.cancel') }}
        </a-button>
        <a-button
          type="primary"
          :loading="drawerLoading"
          @click="handleConfirm"
        >
          {{ $t('handle.confirm') }}
        </a-button>
      </div>
    </a-drawer>
  </div>
</template>

<script>
import PageHeader from '../../components/PageHeader.vue'
import { mapGetters } from 'vuex'
import moment from 'moment'

export default {
  components: {
    PageHeader
  },

  data() {
    return {
      campusId: localStorage.getItem('campusId'),
      updateComponent: new Date().toString(),

      drawerVisible: false,
      drawerLoading: false,
      form: this.$form.createForm(this),
      formItemLayout: {
        labelCol: { span: 6 },
        wrapperCol: { span: 17 }
      }
    }
  },

  computed: {
    ...mapGetters([
      'handleRightsList',
      'categoryRouterList',
      'enrollmentYearList',
      'gradeList',
      'genderList',
      'studentMajorOption'
    ])
  },

  methods: {
    moment,

    handleAdd() {
      this.drawerVisible = true
    },

    // 提交
    handleConfirm() {
      this.form.validateFields((err, values) => {
        if (!err) {
          this.handleSave(values)
        }
      })
    },

    handleSave(values) {
      this.drawerLoading = true
      this.$http(this.$api.ADDSTUDENTMESSAGE, {
        campusId: this.campusId, // 学习中心ID
        name: values.name,
        birthdate: values.birthday
          ? this.moment(values.birthday).format('YYYY-MM-DD')
          : '',
        englishName: values.englishName,
        enrollDate: values.enrollmentTime,
        enrollGrade: values.enrollmentGrade,
        gender: values.gender,
        givenName: values.firstName,
        surname: values.lastName,
        remark: values.remark,
        majorType: values.majorType
      })
        .then(() => {
          this.$message.success(this.$t('public.saveSuccess'))
          this.updateComponent = new Date().toString()
          this.handleClose()
        })
        .catch(() => {
          this.drawerLoading = false
        })
    },

    handleClose() {
      this.drawerVisible = false
      this.drawerLoading = false
      this.$nextTick().then(() => {
        this.form.resetFields()
      })
    },

    handleTap(component) {
      this.$router.push({
        name: component.name
      })
    }
  }
}
</script>
